// https://vuex.vuejs.org/en/actions.html

import productContentService from '@/services/productContentService'
import productAdminService from '@/services/Admin/productService'
import variantService from '@/services/Admin/variantService'
import store from '@/store'
import i18n from '@/i18n'

export default {
  async RefreshAdminProducts (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.RefreshProducts'))
    var apiResult = await productAdminService.getProductAdminOverview()

    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
    }

    var contentOverviewApiResult = await productContentService.getOverview()
    // combine both basic data
    apiResult.value.forEach(product => {
      if (contentOverviewApiResult.success) {
        var contentResult = contentOverviewApiResult.value
        var content = contentResult.find(
          contentItem => contentItem.nodeId === product.contentNodeId
        )
        if (content) {
          product.displayName = content.name
          product.vendorDisplayName = content.vendor
        }
      }
      // set computed properties
      product.typeDisplayName = product.type
      product.recurringDisplayName = ''
      if (product.type === 'Flex' || product.type === 'Fixed') {
        var recurringDisplayName = ''
        if (product.recurringIntervalQuantity > 0) {
          recurringDisplayName = ' ' + product.recurringIntervalQuantity + ' ' + product.recurringTimeInterval
          product.typeDisplayName = product.typeDisplayName + ' (' + product.type + recurringDisplayName + ')'
        }
        product.displayNameWithType = product.displayName + ' (' + product.type + recurringDisplayName + ')'
        product.recurringDisplayName = product.type + recurringDisplayName
      } else {
        product.displayNameWithType = product.displayName
      }
    })

    context.commit('refreshAdminProducts', apiResult.value)
    if (store.state.vendors.list.length < 1) {
      store.dispatch('RefreshVendors')
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
  },
  async CreateProduct (context, product) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.CreateProduct'))
    var apiResult = await productAdminService.create(product)
    if (apiResult.success) {
      context.commit('UpdateProduct', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async UpdateProduct (context, product) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.UpdateProduct'))
    var apiResult = await productAdminService.update(product)
    if (apiResult.success) {
      context.commit('UpdateProduct', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async DeleteProduct (context, productUid) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.DeleteProduct'))
    var apiResult = await productAdminService.deleteProduct(productUid)
    if (apiResult.success) {
      context.commit('DeleteProduct', productUid)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async CreateVariant (context, variant) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.CreateVariant'))
    var apiResult = await variantService.create(variant)
    if (apiResult.success) {
      context.commit('UpdateProduct', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async UpdateVariant (context, variant) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.UpdateVariant'))
    var apiResult = await variantService.update(variant)
    if (apiResult.success) {
      context.commit('UpdateProduct', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async DeleteProductVariant (context, productVariant) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Product.DeleteVariant'))
    var apiResult = await variantService.delete(productVariant)
    store.dispatch('RemoveLoadingMessage', loadingId)
    if (apiResult.success) {
      context.commit('UpdateProduct', apiResult.value)
    }
    return apiResult
  },
}
